import Hero from "@/components/Hero";
import MarqueeStrip from "@/components/Marquee";
import FeaturedCategories from "@/components/FeaturedCategories";
import HotOffers from "@/components/HotOffers";
import BestSellers from "@/components/BestSellers";
import WhyChoose from "@/components/WhyChoose";
import BeforeAfter from "@/components/BeforeAfter";
import Reviews from "@/components/Reviews";
import InstagramGrid from "@/components/InstagramGrid";
import SpecialOffer from "@/components/SpecialOffer";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Hero />
      <MarqueeStrip />
      <HotOffers />
      <FeaturedCategories />
      <BestSellers />
      <WhyChoose />
      <BeforeAfter />
      <SpecialOffer />
      <Reviews />
      <InstagramGrid />
    </div>
  );
}
